import { render, staticRenderFns } from "./marketing-campaign-stats.vue?vue&type=template&id=392abe27"
import script from "./marketing-campaign-stats.vue?vue&type=script&lang=js"
export * from "./marketing-campaign-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports